import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, shareReplay, switchMap } from "rxjs";
import { environment } from "../../environments/environment";
import { BaseService } from "./base.service";
import { FilterChip } from "../models/filter-chip";
import { Group, GroupMembership } from "../models/group";
import { User } from "../models/user";

@Injectable({ providedIn: 'root' })
export class GroupMembersService extends BaseService {
    private groupsSubject = new BehaviorSubject<GroupMembership[]>([]);
    groups$ = this.groupsSubject.asObservable();

    private sourceUpdatedSubject = new BehaviorSubject<boolean>(false);
    sourceUpdated$ = this.sourceUpdatedSubject.asObservable();

    constructor(private http: HttpClient) {
        super();
    }

    fetchGroups() {
        this.http.get<GroupMembership[]>(environment.apiUrl + 'groups/membership/search').subscribe(groups => {
            this.groupsSubject.next(groups);
        });
    }

    addGroupMemberships(group: Group, users: User[]) {
        let memberships = users.map(u => <GroupMembership>{ groupId: group.id, userId: u.id});
        this.http.post(environment.apiUrl + `groups/${group.id}/membership`, memberships).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    addUserToGroups(groups: Group[], user: User) {
        let memberships = groups.map(g => <GroupMembership>{ groupId: g.id, userId: user.id});
        this.http.post(environment.apiUrl + `user/${user.id}/membership`, memberships).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    updateGroup(updatedGroup: Group) {
        throw Error();
        this.http.put(environment.apiUrl + `groups/${updatedGroup.id}`, updatedGroup).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    deleteGroupMembership(groupId: number, userId: number) {
        this.http.delete(environment.apiUrl + `groups/${groupId}/users/${userId}`).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    filterGroups(filters: FilterChip[]) {
        return this.sourceUpdatedSubject.pipe(
            switchMap(() => {
                const keywords = filters.filter(c => c.chip == null).reduce((v, c) => v + ' ' + c.value, '');
                const propertyValues = filters.reduce((v, c) => { if (c.chip != null) v[c.chip] = c.value; return v; }, <{ [key: string]: string }>{});
                const filter = { keywords, propertyValues };
                const filterQuery = this.serialize(filter);
                console.log(filterQuery, filter);
                return this.http.get<Group[]>(environment.apiUrl + 'groups/search?' + filterQuery);
            }),
            shareReplay()
        );
    }
}